import classNames from 'classnames';
import React from 'react';
import { formatFileSize } from '../../utils/text';
import './DocumentDownload.scss';

export interface DocumentDownloadLinkProps {
  href?: string;
  name: string;
  fileSize?: number;
  fileType: string;
  action?: string;
  invert?: boolean;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
}

export interface DocumentDownloadButtonProps {
  href?: never;
  name: string;
  fileSize?: number;
  fileType: string;
  action?: string;
  invert?: boolean;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
}

const DocumentDownload = ({
  name,
  fileSize = 0,
  fileType,
  href,
  action = 'Download',
  invert = false,
  className,
  ...rest
}: DocumentDownloadLinkProps | DocumentDownloadButtonProps) => {
  const classes = classNames(
    'mss-document-download',
    {
      'mss-document-download--invert': invert
    },
    className
  );

  const children = (
    <>
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="47"
          fill="none"
          role="presentation"
          aria-hidden="true"
        >
          <path
            fill="#333"
            fillRule="evenodd"
            d="M32.585 8.784 23.698 0H4.444C1.99 0 0 1.967 0 4.392v38.07c0 2.424 1.99 4.391 4.444 4.391h28.141c2.454 0 4.444-1.967 4.444-4.392V13.177l-4.444-4.393Zm0 33.466H4.444V4.182h14.822c-.003.07-.012.14-.012.21v8.785c0 2.426 1.99 4.393 4.444 4.393h8.887v24.68Z"
            clipRule="evenodd"
          />
          <path
            stroke="#333"
            strokeLinecap="square"
            strokeWidth="1.6"
            d="M10.483 23.636H26.52M10.483 29.636H26.52M10.483 35.636H26.52"
          />
        </svg>
      </div>
      <div>
        <span className="mss-document-download__title">{name}</span>
        <span className="mss-document-download__details">
          {fileType}, {formatFileSize(fileSize)}
        </span>
        <span className="mss-document-download__action">{action}</span>
      </div>
    </>
  );

  if (href) {
    return (
      <a href={href} rel="noopener noreferrer" target="_blank" className={classes} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <button type="button" className={classes} {...rest}>
      {children}
    </button>
  );
};

export default DocumentDownload;
